// extracted by mini-css-extract-plugin
export default {"market":"styles_market__sACOJ","body":"styles_body__gKXe6","cups":"styles_cups__EtV74","lines":"styles_lines__8FUGa","bets":"styles_bets__Fz3kd"};